export default class FormatTimeViewModel {
  constructor() {
    this.title = '';
    this.subTitle = '';
    this.main = false;
  }
}